export const VRBO_WEB_SEARCH_NEW_FILTER_MENU =
    'VRBO_WEB_SEARCH_NEW_FILTER_MENU';
